import { Component, Input, OnInit, OnChanges, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ApiservicesService } from 'src/app/services/apiservices.service';

import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
// import { OrderReviewComponent } from './order-review/order-review.component';
import { OrderReviewComponent } from './order-review/order-review.component';
import {
  CommonModule,
  DatePipe,
  DecimalPipe,
  NgFor,
  NgIf,
} from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { ListingAngular15Module } from 'listing-angular15';

import { DemoMaterialModule } from 'src/app/material/material.module';
@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.scss'],
})
export class OrderListComponent implements OnInit, OnChanges {
  public login_user_details: any = {};

  constructor(
    public router: Router,
    public cookieService: CookieService,
    public activatedRoute: ActivatedRoute,
    private apiservice: ApiservicesService,
    public dialog: MatDialog,
    public matSnackBar: MatSnackBar
  ) {
    this.login_user_details = this.cookieService.get('login_user_details')
      ? JSON.parse(this.cookieService.get('login_user_details'))
      : {};
    console.log('login_user_details===>', this.login_user_details);
  }

  @Input() userId!: string;
  @Input() heading: string = 'Order List';
  @Input() tabledatatalist: any[] = [];
  orders: any[] = [];
  loading = false;
  public loader = false;
  // public tabledatatalist: any = [];

  date_search_source_count: any = 0;

  public listprogressBar: any = false;
  tabledata_header_skip: any = ['_id'];

  modify_header_array: any = {
    user_name_str: 'Name',
    user_email_str: 'Email',
    order_number: 'Order Number',
    total_amount: 'Amount',
    created_on: 'Payment On',
  };

  public base_api_url = environment.api_url;

  deleteendpoint = '';
  updateendpoint = '';
  date_search_source: any = 'cart_management/order-list';
  date_search_endpoint: any = 'cart_management/order-list';
  tablename = 'order_list';
  editroute = '';
  tabledata_detail_skip: any = ['_id'];

  statusarray: any = [
    { val: 1, name: 'Active' },
    { val: 0, name: 'Inactive' },
  ];

  search_settings: any = {
    datesearch: [
      {
        startdatelabel: 'Payment On Start Date',
        enddatelabel: 'Payment On End Date',
        submit: 'Search',
        field: 'created_on',
      },
    ],

    textsearch: [{ label: 'Search By Order Number', field: 'order_number' }],

    search: [],
  };

  searchendpoint = 'cart_management/order-list';

  sortdata: any = {
    type: 'desc',
    field: 'created_on',
    options: [
      'user_name_str',
      'user_email_str',
      'order_number',
      'total_amount',
      'created_on',
    ],
  };

  datacollection: any = 'cart_management/order-list';

  limitcond: any = {
    limit: 10,
    skip: 0,
    pagecount: 1,
  };

  public orderList_updatetable: boolean = false;

  public customlistenbutton: any = {
    flag: true,
    tooltipflag: true,
    buttons: [],
  };

  // Role list configaration
  libdata: any = {
    basecondition: {},
    detailview_override: [
      { key: 'role_name', val: 'Role Name' },
      { key: 'description', val: 'Description' },
      { key: 'priority', val: 'Priority' },
      { key: 'status', val: 'Status' },
      { key: 'updatedon_datetime', val: 'Updated On' },
      { key: 'createdon_datetime', val: 'Joined On' },
    ],
    updateendpoint: 'admin/role-status-change',
    hidedeletebutton: true,
    hideviewbutton: true,
    hideeditbutton: true,
    hidestatustogglebutton: true,
    hidemultipleselectbutton: true,
    hideaction: false,
    updateendpointmany: 'admin/role-status-change',
    deleteendpointmany: 'content/content-delete',

    tableheaders: [
      'user_name_str',
      'user_email_str',
      'order_number',
      'total_amount',
      'created_on',
    ],

    colpipes: [
      { type: 'datetime', col: 'created_on', format: 'MMMM D YYYY, h:mm A' },
    ],
    custombuttons: [
      {
        label: 'Preview',
        type: 'listner',
        id: 'preview_btn',
        tooltip: 'Preview',
        name: 'preview_btn',
        classname: 'previewButton',
      },
      {
        label: 'Email Resend',
        type: 'listner',
        headermessage: 'Email Resend',
        tooltip: 'Email Resend',
        name: 'emailResend',
        classname: 'emailResend',
        id: 'email_resend',
      },
      {
        label: 'Invoice Download',
        type: 'listner',
        headermessage: 'Invoice Download',
        tooltip: 'Invoice Download',
        name: 'invoiceDownload',
        classname: 'invoiceDownload',
        id: 'invoice_download',
      },
    ],
  };

  ngOnInit() {
    if (this.login_user_details.userinfo?.user_type === 'is_admin') {
      if (
        !this.search_settings.search.some((x: any) => x.field === 'user_id')
      ) {
        this.search_settings.search.push({
          label: 'Search by Name',
          field: 'user_id',
          values: '',
          serversearchdata: {
            endpoint: 'refund-processing/user-name-autocomplete-search',
          },
        });
      }
    }
    if (this.login_user_details.userinfo?.user_type !== 'is_admin') {
      this.libdata.custombuttons.push({
        label: 'Refund Preview',
        type: 'listner',
        headermessage: 'Refund Preview',
        tooltip: 'Refund Action',
        name: 'refundButton3',
        classname: 'refundButton3',
        id: 'refund_btn',
      });
    }
    if (this.userId) {
      this.libdata.basecondition.user_id =
        this.login_user_details?.userinfo?._id;
    }
    console.log('this.activatedRoute.data', this.activatedRoute.data);
    this.activatedRoute.data.subscribe((response: any) => {
      console.log('activatedRoute', response);
      if (response.response.status === 'success') {
        this.tabledatatalist = response?.response?.results?.res || [];

        console.log('tabledatatalist:::::::::::::::::::', this.tabledatatalist);
      }
    });
    let payload;
    if (!this.userId) {
      payload = {
        condition: {
          limit: 10,
          skip: 0,
        },
        searchcondition: {},
        sort: {
          type: 'desc',
          field: 'created_on',
        },
        project: {},
      };
    } else {
      payload = {
        condition: {
          limit: 10,
          skip: 0,
        },
        searchcondition: {
          user_id: this.login_user_details?.userinfo?._id,
        },
        sort: {
          type: 'desc',
          field: 'created_on',
        },
        project: {},
      };
    }
    this.apiservice
      .getHttpDataPost('cart_management/order-list-count', payload)
      .subscribe((response: any) => {
        if (response && response.count) {
          this.date_search_source_count = response.count;
        }
      });
  }

  ngOnChanges(): void {
    if (this.userId) this.fetchOrders();
  }

  listenLiblistingChange(data: any = null) {
    console.log('onLiblistingButtonChange', data);
    const rowData = data?.custombuttonclick?.data;
    console.log('rowData=======>>>', rowData);

    if (data?.custombuttonclick?.btninfo?.id === 'preview_btn') {
      this.loader = true;
      this.apiservice
        .getHttpDataPost('cart_management/order-preview', {
          order_id: rowData._id,
        })
        .subscribe(
          (res: any) => {
            if (res.status === 'success') {
              const dialogRef = this.dialog.open(OrderReviewComponent, {
                panelClass: 'custom-modalbox',
                data: {
                  key: data.custombuttonclick.btninfo.previewlist,
                  value: res.result || {},
                  override: this.libdata.detailview_override,
                },
              });
              this.loader = false;
            } else {
              this.matSnackBar.open('Failed to load order preview.', 'Close', {
                duration: 3000,
                panelClass: ['snackbar-error'],
              });
              this.loader = false;
            }
          },
          (err) => {
            console.error('Order preview error:', err);
            this.matSnackBar.open(
              'Something went wrong while loading preview.',
              'Close',
              {
                duration: 3000,
                panelClass: ['snackbar-error'],
              }
            );
            this.loader = false;
          }
        );
    }

    // === Resend email========
    if (data?.custombuttonclick?.btninfo?.id === 'email_resend') {
      this.loader = true;

      this.apiservice
        .getHttpDataPost('cart_management/Resend-mail-invoice-pdf-by-orderid', {
          order_id: rowData._id,
        })
        .subscribe(
          (res: any) => {
            if (res.status === 'success') {
              this.matSnackBar.open(
                'Invoice email resent successfully.',
                'Close',
                {
                  duration: 3000,
                  panelClass: ['snackbar-success'],
                }
              );
              this.loader = false;
            } else {
              this.matSnackBar.open(
                'Failed to resend invoice email.',
                'Close',
                {
                  duration: 3000,
                  panelClass: ['snackbar-error'],
                }
              );
              this.loader = false;
            }
          },
          (err) => {
            console.error('Email resend error:', err);
            this.matSnackBar.open(
              'Something went wrong while resending email.',
              'Close',
              {
                duration: 3000,
                panelClass: ['snackbar-error'],
              }
            );
            this.loader = false;
          }
        );
    }

    // === Refund========
    if (data?.custombuttonclick?.btninfo?.id === 'refund_btn') {
      this.loader = true;
      this.apiservice
        .getHttpDataPost('cart_management/order-preview', {
          order_id: rowData._id,
        })
        .subscribe(
          (res: any) => {
            console.log('Resssss----->', res);
            if (res.status === 'success') {
              const dialogRef = this.dialog.open(refunRequestModal, {
                data: res.result || {},
                panelClass: ['custom-modalbox', 'refund-modal'],
              });
              this.loader = false;
            } else {
              this.matSnackBar.open('Failed to load request moadl', 'Close', {
                duration: 3000,
                panelClass: ['snackbar-error'],
              });
              this.loader = false;
            }
          },
          (err) => {
            console.error('Order preview error:', err);
            this.matSnackBar.open(
              'Something went wrong while loading request modal.',
              'Close',
              {
                duration: 3000,
                panelClass: ['snackbar-error'],
              }
            );
            this.loader = false;
          }
        );
    }

    // === Invoice Download ===
    if (data?.custombuttonclick?.btninfo?.id === 'invoice_download') {
      this.loader = true;
      const invoiceUrl = rowData?.invoice_pdf_url;

      if (invoiceUrl) {
        window.open(invoiceUrl, '_blank');
        this.matSnackBar.open('Invoice downloaded successfully.', 'Close', {
          duration: 3000,
          panelClass: ['snackbar-success'],
        });
      } else {
        this.matSnackBar.open('Invoice URL not found.', 'Close', {
          duration: 3000,
          panelClass: ['snackbar-error'],
        });
      }

      this.loader = false;
    }
  }

  onLiblistingButtonChange(data: any = null) {
    console.log('onLiblistingButtonChange', data);
  }

  fetchOrders(): void {
    // this.loading = true;
    // this.loader = true;
  }
}

@Component({
  selector: 'refundModal',
  templateUrl: 'refundRequestModal.html',
  standalone: true,
  styleUrls: ['./refundRequestFormModal.scss'],
  imports: [
    NgFor,
    NgIf,
    MatCheckboxModule,
    MatButtonModule,
    DatePipe,
    DecimalPipe,
    MatDialogModule,
    DemoMaterialModule,
  ],
})
export class refunRequestModal {
  public modalData: any = {};
  selected = new Set<number>();
  submitting = false;
  public userID: any;
  login_user_details: any;
  public isLoading = false;

  constructor(
    public dialogRef: MatDialogRef<refunRequestFormModal>,
    private apiservice: ApiservicesService,
    public cookieService: CookieService,
    public matSnackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog
  ) {
    console.log('data+++++++++++++++', data);
  }

  ngOnInit() {
    this.login_user_details = this.cookieService.get('login_user_details')
      ? JSON.parse(this.cookieService.get('login_user_details'))
      : {};
    console.log('&& this.login_user_details======>', this.login_user_details);
    this.modalData = this.data || {};
    console.log('this.modalDatarequest', this.modalData);
  }

  trackProduct = (i: number, p: any) =>
    p?.product_id || p?._id || p?.id || p?.sku || i;

  // get products(): any[] {
  //   return this.modalData?.Product_details || [];
  // }

  get products(): any[] {
    const productDetails = this.modalData?.Product_details || [];
    const productsInfo = this.modalData?.products || [];
    console.log('productsInfo----->', productsInfo);

    if (!productDetails.length || !productsInfo.length) {
      return productDetails;
    }

    return productDetails.map((detail: any) => {
      const matchingProduct = productsInfo.find(
        (p: any) => p.product_id === detail._id
      );
      // console.log('matchingProduct====>', matchingProduct);

      return {
        ...detail,
        verient_id: matchingProduct?.verient_id,
      };
    });
  }

  get allSelected(): boolean {
    return (
      this.products.length > 0 && this.selected.size === this.products.length
    );
  }

  onToggle(index: number, checked: boolean) {
    checked ? this.selected.add(index) : this.selected.delete(index);
  }

  onToggleAll(checked: boolean) {
    this.selected.clear();
    if (checked) {
      this.products.forEach((_, i) => this.selected.add(i));
    }
  }

  getSelectedProducts() {
    return this.products
      .map((p, i) => ({ p, i }))
      .filter(({ i }) => this.selected.has(i))
      .map(({ p, i }) => ({
        index: i,
        productId: p.product_id || p._id || p.id || p.sku || null,
        name: p.product_name ?? null,
        quantity: p.quantity ?? null,
        price: p.price ?? p.preorder_price ?? null,
        selected_size: p.selected_size ?? null,
        selected_color: p.selected_color ?? null,
        product_image: p.product_image ?? null,
        verient_id: p.verient_id ?? null,
      }));
  }

  async submitRefundRequest() {
    this.isLoading = true;
    console.log('callllllllllllllllll submit button', this.isLoading);
    const payload = {
      orderId:
        this.modalData?.order_id ||
        this.modalData?.orderId ||
        this.modalData?._id ||
        null,
      userId:
        this.modalData?.user_id || this.cookieService.get('user_id') || null,
      products: this.getSelectedProducts(),
    };

    console.log('Checking for existing refund requests with payload:', payload);

    if (payload.products.length === 0) {
      this.matSnackBar.open('Please select at least one product.', 'Close', {
        duration: 3000,
        panelClass: ['snackbar-error'],
      });
      this.isLoading = false;
      return;
    }
    this.apiservice
      .getHttpDataPost(
        'refund-processing/check-refund-request-products-history',
        payload
      )
      .subscribe({
        next: (response: any) => {
          if (response.status === true) {
            console.log('No existing request found. Opening modal.');
            const dialogRef = this.dialog.open(refunRequestFormModal, {
              panelClass: ['custom-modalbox', 'refund-requestform-modalbox'],
              data: payload,
            });

            dialogRef.afterClosed().subscribe((result) => {
              console.log('The dialog was closed');
              if (result) {
                console.log('Result from modal:', result);
              }
            });
            this.dialogRef.close();
          } else {
            this.matSnackBar.open(
              response.message ||
                'You have already submitted a refund request for a selected product.',
              'Close',
              {
                duration: 30000,
                panelClass: ['snackbar-error'],
              }
            );
          }
          this.isLoading = false;
        },
        error: (err) => {
          console.error('API Error checking refund history:', err);
          this.matSnackBar.open(
            'An error occurred. Please try again.',
            'Close',
            {
              duration: 3000,
              panelClass: ['snackbar-error'],
            }
          );
          this.isLoading = false;
        },
      });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

// -----------------------------Refund Request form---------------------//

@Component({
  selector: 'refundFormModal',
  templateUrl: 'refundRequestFormModal.html',
  standalone: true,
  styleUrls: ['./refundRequestFormModal.scss'],
  imports: [
    NgFor,
    NgIf,
    MatCheckboxModule,
    MatButtonModule,
    DatePipe,
    DecimalPipe,
    MatDialogModule,
    DemoMaterialModule,
    ListingAngular15Module,
  ],
})
export class refunRequestFormModal {
  public modalData: any = {};
  public loader: boolean = false;
  public editFormData: any = null;
  public formfieldrefreshdata: any = null;
  public formfieldrefresh: any = null;
  public userformdata: any = null;
  login_user_details: any;
  userID: any;
  userType: any;
  showConfirmModal = false;
  public formDataToSubmit: any = null;
  constructor(
    public dialogRef: MatDialogRef<refunRequestFormModal>,
    private apiservice: ApiservicesService,
    public cookieService: CookieService,
    public matSnackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log('data==============>', data);
    this.login_user_details = this.cookieService.get('login_user_details')
      ? JSON.parse(this.cookieService.get('login_user_details'))
      : {};
    console.log('login_user_details===12354>', this.login_user_details);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit() {
    this.modalData = this.data;
    console.log('modalDatarequest===123654789========>', this.modalData);
    this.userID = this.login_user_details.userinfo._id;
    console.log('userID====>', this.userID);

    this.userType = this.login_user_details.userinfo.user_type;
    console.log('userType=====>', this.userType);

    this.initializeForm();
  }

  initializeForm() {
    console.log('this.formValue?.icon_image========', this.editFormData?.image);
    this.userformdata = {
      successmessage: 'Added Successfully !!',
      submittext: 'Submit',
      apiUrl: this.apiservice.baseUrl,
      resettext: 'Reset',
      canceltext: 'Cancel',
      hidereset: this.editFormData ? true : false,
      jwttoken: '',

      fields: [
        {
          label: 'Comment',
          name: 'comment_text',
          type: 'text',
          rows: 5,
          cols: 5,

          // hint: ' Notes ',

          validations: [{ rule: 'required', message: 'Comments is Required' }],
        },

        {
          label: 'Request Type',
          name: 'request_type',
          type: 'select',
          val: [
            { val: 'REFUND', name: 'Refund' },
            { val: 'REPRINT', name: 'Reprient' },
          ],
          multiple: false,
          validations: [
            { rule: 'required', message: 'Request Type is Required' },
          ],
        },

        {
          label: 'Upload Images',
          name: 'image',
          type: 'file',
          multiple: true,
          prefix: Date.now(),

          path: 'divine-infinity-being/refund-assets/',
          baseurl: 'divine-infinity-being/refund-assets/',
          bucket: 'all-frontend-assets',
          apiurl: this.apiservice.baseUrl + 'user-profile/request-bucket-url',
          apideleteurl:
            this.apiservice.baseUrl + 'user-profile/delete-image-from-bucket',
        },

        {
          label: 'Upload Videos',
          name: 'video',
          type: 'file',
          multiple: true,
          prefix: Date.now(),

          path: 'divine-infinity-being/refund-assets',
          baseurl: 'divine-infinity-being/refund-assets',
          bucket: 'all-frontend-assets',
          apiurl: this.apiservice.baseUrl + 'user-profile/request-bucket-url',
          apideleteurl:
            this.apiservice.baseUrl + 'user-profile/delete-image-from-bucket',
        },
      ],
    };
  }

  getS3Url(img: any): string {
    const base = (img?.baseurl || img?.path || '').replace(/^\/|\/$/g, '');
    const key = base ? `${base}/${img.fileservername}` : img.fileservername;
    return `https://s3.us-east-1.amazonaws.com/${
      img.bucket
    }/${encodeURIComponent(key).replace(/%2F/g, '/')}`;
  }

  // 2. This function now shows the confirmation modal.

  listenFormFieldChange(val: any) {
    if (val?.field === 'formcancel') {
      this.onNoClick();
      return;
    }
    if (val?.field === 'fromsubmit') {
      this.formDataToSubmit = val;
      this.showConfirmModal = true;
    }
  }

  closeConfirmModal(): void {
    this.showConfirmModal = false;
    this.formDataToSubmit = null;
  }

  submitConfirmedData(): void {
    if (!this.formDataToSubmit) {
      console.error('Cannot submit because formDataToSubmit is null.');
      return;
    }

    this.loader = true;
    const formData = this.formDataToSubmit.fromval;

    if (!formData) {
      console.error(
        "Submission failed: 'fromval' property is missing from the form event."
      );
      this.loader = false;
      this.closeConfirmModal();
      return;
    }

    const payload = {
      order_id: this.modalData?.orderId || null,
      user_id: this.userID || null,
      user_type: this.userType || null,
      products: this.modalData?.products || [],
      request_type: formData.request_type,
      comment_text: formData.comment_text,
      refund_request_status: 'PENDING_CUSTOMER_RESPONSE',
      image: formData.image || [],
      video: formData.video || [],
    };

    this.apiservice
      .getHttpDataPost(
        'refund-processing/shopping-refund-request-create',
        payload
      )
      .subscribe({
        next: (response: any) => {
          if (response.status === 'success') {
            // Show success message and close the main dialog
            this.matSnackBar.open(
              'Refund request submitted successfully!',
              'Close',
              {
                duration: 3000,
                panelClass: ['snackbar-success'],
              }
            );
            this.dialogRef.close(true);

            // --- START: Added Activity Logging ---
            const refundRequestId = response.results?._id;

            if (refundRequestId) {
              const actorName =
                this.login_user_details?.userinfo?.name ||
                this.login_user_details?.userinfo?.firstname +
                  (this.login_user_details?.userinfo?.lastname
                    ? ' ' + this.login_user_details.userinfo.lastname
                    : '') ||
                'Customer';

              const activityPayload: any = {
                user_id: this.userID,
                refundRequestId: refundRequestId,
                type: 'CREATED',
                description: `${actorName} submitted a new refund request`,
                actor: {
                  userId: this.userID,
                  role: this.userType || null,
                  name: actorName,
                  email: this.login_user_details?.userinfo?.email || '',
                },
                metadata: {},
              };

              const firstImg =
                Array.isArray(formData.image) && formData.image.length
                  ? formData.image[0]
                  : null;
              const firstVideo =
                Array.isArray(formData.video) && formData.video.length
                  ? formData.video[0]
                  : null;

              if (firstImg) {
                activityPayload.metadata.image = this.getS3Url(firstImg);
              }
              if (firstVideo) {
                activityPayload.metadata.video = this.getS3Url(firstVideo);
              }

              // Call the second API to add the activity
              this.apiservice
                .getHttpDataPost(
                  'refund-activity/refund-activity-add',
                  activityPayload
                )
                .subscribe({
                  next: (activityRes) =>
                    console.log('Activity logged successfully:', activityRes),
                  error: (activityErr) =>
                    console.error('Failed to log activity:', activityErr),
                });
            }
            // --- END: Added Activity Logging ---
          } else {
            this.matSnackBar.open(
              response.message || 'Failed to submit request.',
              'Close',
              {
                duration: 3000,
                panelClass: ['snackbar-error'],
              }
            );
          }

          this.loader = false;
          this.closeConfirmModal();
        },
        error: (err) => {
          console.error('Submission Error:', err);
          this.matSnackBar.open(
            'An error occurred during submission.',
            'Close',
            {
              duration: 3000,
              panelClass: ['snackbar-error'],
            }
          );
          this.loader = false;
          this.closeConfirmModal();
        },
      });
  }
}
